import { createContext, useContext } from 'react';
import { useToastMessage, ToastConfig } from '../ai2/hooks/useToastMessage';
import { Toast } from 'react-bootstrap';

interface ToastContextType {
  showToast: boolean;
  toastMessage: React.ReactElement | string | null;
  setToast: (
    message: React.ReactElement | string,
    config?: ToastConfig,
  ) => void;
  closeToast: () => void;
}

// Create a context with a better default value
const ToastContext = createContext<ToastContextType | null>(null);

// Provider component
export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const { showToast, closeToast, toastMessage, setToast } = useToastMessage();

  return (
    <ToastContext.Provider
      value={{ showToast, closeToast, toastMessage, setToast }}
    >
      {children}
      <Toast
        animation
        show={showToast}
        onClose={closeToast}
        className="team-toast"
      >
        {toastMessage && <Toast.Body>{toastMessage}</Toast.Body>}
      </Toast>
    </ToastContext.Provider>
  );
};

// Hook to use the toast context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
